import React from 'react';
import ReactDOM from 'react-dom';
import styles from './modals.module.css';

// Reminder shown when the user hits Generate without having removed the
// background on any image. Offers to open the Remove Background flow or
// proceed with generation anyway. Mirrors the AddZoomModal styling.
export const BgReminderModal = ({
  isOpen,
  onClose,
  onRemoveBackground,
  onContinue,
  continueLabel = 'Generate anyway'
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.removeBgModalOverlay} onClick={onClose}>
      <div className={`${styles.addZoomModal} ${styles.bgReminderModal}`} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.addZoomModalClose} onClick={onClose} aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="#505050"/>
          </svg>
        </button>

        <div className={styles.bgReminderText}>
          <span className={styles.bgReminderHeadline}>
            You haven't removed the background on any of your product images yet.
          </span>
          <span className={styles.bgReminderSubtext}>
            Removing backgrounds usually produces cleaner infographics.
          </span>
        </div>

        <div className={styles.addZoomModalActions}>
          <button type="button" className={styles.addZoomModalPrimaryButton} onClick={onRemoveBackground}>
            Remove backgrounds
          </button>
          <button type="button" className={styles.addZoomModalBackLink} onClick={onContinue}>
            {continueLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
